import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GlobalDataLoadingGuard implements CanActivate {
  public constructor(private readonly globalService: GlobalService) {}

  public canActivate(): Observable<boolean> {
    if (!this.globalService.globalInfo.isLoaded) {
      return this.globalService.loadData().pipe(
        catchError((err) => {
          const isReload = confirm('Не удалось загрузить страницу. Перезагрузите страницу');
          if (isReload) {
            window.location.reload();
          }
          return throwError(err);
        }),
        map(() => true)
      );
    } else {
      return of(true);
    }
  }
}
